import React, { Component } from 'react'
import { Checkbox } from 'antd'
import _ from 'lodash'
import { Field, Row, Col } from '../../../../../styles'
import { Organization } from './styled'
import { withTranslation } from 'react-i18next'

class OrganizationPicker extends Component {
  handleChange = id => {
    const { onChange } = this.props

    if (onChange) {
      onChange(id)
    }
  }

  render() {
    const { list, selectedOrganizations, t, encoder, isPrivate } = this.props

    return (
      <Field>
        <Field.Label>{t('labels:select_organization')}</Field.Label>
        <div className="org-group">
          <div className="org-group-row">
            {!_.isEmpty(list) &&
              list.map(organization => {
                const { id, title, logo } = organization
                const isDisable =
                  !_.isEmpty(selectedOrganizations) &&
                  !selectedOrganizations.includes(id) &&
                  encoder === 'conference' &&
                  isPrivate
                    ? true
                    : false

                return (
                  <div className="org-group-list" key={id}>
                    <Organization
                      active={
                        !_.isEmpty(selectedOrganizations) &&
                        selectedOrganizations.includes(id)
                      }
                      onClick={() => this.handleChange(id)}
                      disabled={isDisable}
                      className="org-group-btn"
                    >
                      <Organization.Checkbox>
                        <Checkbox
                          checked={selectedOrganizations.includes(id)}
                        />
                      </Organization.Checkbox>
                      <Organization.Image
                        src={logo ? logo.link : ''}
                        alt=""
                        className="org-image-user"
                      />
                      <Organization.Name>{title}</Organization.Name>
                    </Organization>
                  </div>
                )
              })}
          </div>
        </div>
      </Field>
    )
  }
}

export default withTranslation()(OrganizationPicker)
